import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import Table from "../../components/common/Table"
import strings from "../../localization/strings"
import { IClientDocument } from "../../models"
import { red500 } from "material-ui/styles/colors"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import ExternalLink from "../../components/common/externalLink/ExternalLink"
interface IProps {
	readonly: boolean
	clients: IClientDocument[]
	selectedClientIds: string[]
	total: number
	offset: number
	limit: number
	limitOptions: number[]
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	handleRowClick(clientId: string): void
	handleSelect(selectedClientIds: string[]): void
}

const ClientsTable: React.SFC<IProps> = (props: IProps) => {
	return (
		<Table
			readonly={props.readonly}
			allowClickRow
			unClickableCols={[0]}
			items={props.clients}
			handleClickRow={client => props.handleRowClick(client.Id)}
			handleSelect={clients => props.handleSelect(clients.map(item => item.Id))}
			total={props.total}
			offset={props.offset}
			limit={props.limit}
			limitOptions={props.limitOptions}
			onPageClick={props.onPageClick}
			onLimitChange={props.onLimitChange}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={{ width: 25, paddingLeft: 5, paddingRight: 5 }} />
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Clients}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.HIERARCHY}</TableHeaderColumn>
					<TableHeaderColumn style={{ textAlign: "left" }}>{strings.Client_ID}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody showRowHover={true} deselectOnClickaway={false}>
				{props.clients.map(client => {
					const hierarchyPathLabelToRoot = hierarchyHelper.getFullPathLabel(client.HierarchyId)
					return (
						<TableRow key={client.Id} selected={props.selectedClientIds.indexOf(client.Id) !== -1}>
							<TableRowColumn style={{ width: 25, paddingLeft: 5, paddingRight: 5, paddingTop: 4 }}>
								<ExternalLink
									url={"/client-details/" + client.Id}
								/>
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }} title={client.Name}>
								{client.Name}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer", color: hierarchyPathLabelToRoot === strings.Hierarchy_Removed && red500 }} title={hierarchyPathLabelToRoot === strings.Hierarchy_Removed ? "" : hierarchyPathLabelToRoot}>
								{hierarchyPathLabelToRoot}
							</TableRowColumn>
							<TableRowColumn style={{ textAlign: "left", cursor: "pointer" }} title={client.ExternalId}>
								{client.ExternalId}
							</TableRowColumn>
						</TableRow>
					)
				})}
			</TableBody>
		</Table >
	)
}

export default ClientsTable